<template>
  <span class="mmm-svg-icon" :disabled="disabled" :class="wrapperClass" v-html="svgContent" @click.prevent="handleClick"></span>
</template>

<script>
/**
 * SVG Icon Component - Vue-compatible wrapper for inline SVGs
 *
 * This component fetches SVG files and injects them as inline SVG elements
 * while preserving all Vue reactive properties (classes, events, etc.)
 *
 * Usage:
 *   <svg-icon src="/images/icon.svg" :class="myClass" @click="handleClick" alt="icon" />
 */


let svgCache = {}

export default {
  name: 'SvgIcon',
  emits: ['click'],
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      svgContent: '',
      svgCache: {}
    }
  },
  computed: {
    // Pass through the class bindings to the wrapper
    wrapperClass() {
      return this.$attrs.class || ''
    }
  },
  watch: {
    src: {
      immediate: true,
      handler(newSrc) {
        this.loadSvg(newSrc)
      }
    }
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event)
    },
    async loadSvg(src) {
      if ( svgCache[src] ) {
        this.svgContent = svgCache[src]
        return
      }

      try {
        const response = await fetch(src)
        if (!response.ok) {
          console.error(`Failed to load SVG: ${src}`)
          return
        }

        let svgText = await response.text()

        // Add alt text as title if provided
        if (this.alt && !svgText.includes('<title>')) {
          svgText = svgText.replace('<svg', `<svg><title>${this.alt}</title>`)
        }

        // Remove any width/height attributes to allow CSS sizing
        svgText = svgText.replace(/\s(width|height)="[^"]*"/g, '')
        svgCache[src] = svgText
        this.svgContent = svgText
      } catch (error) {
        console.error(`Error loading SVG from ${src}:`, error)
      }
    }
  }
}
</script>
